import { z } from "zod"

// TODO: @jarren Move the atlas socket stuff out of this file.

export const LocationPingSchema = z.object({
    latitude: z.number(),
    longitude: z.number(),
    accuracy: z.number().nullable(),
    altitude: z.number().nullable(),
    heading: z.number().nullable(),
    speed: z.number().nullable(),
    batteryPercentage: z.number().min(0).max(100).nullable().catch(null),
    timestamp: z.number(),
})

export type LocationPing = z.infer<typeof LocationPingSchema>

export const UserLocationSchema = z
    .object({
        orgId: z.string(),
        projectId: z.string(),
        userId: z.string(),
        disconnectedAt: z.number().nullable().default(null),
        expiresAt: z.number(),
    })
    .and(LocationPingSchema)

export type UserLocation = z.infer<typeof UserLocationSchema>

export const AtlasSocketConnectionMetadataSchema = z.object({
    orgId: z.string(),
    projectId: z.string(),
    userId: z.string(),
})

export type AtlasSocketConnectionMetadata = z.infer<typeof AtlasSocketConnectionMetadataSchema>

export type StoppedBroadcastingLocation = AtlasSocketConnectionMetadata
